export default function formatName(nome: string): string {
  const words = nome.toLowerCase().split(' ');

	if (words.length === 1)
		return `${words[0][0].toUpperCase()} ..`;

  for (let i = 0; i < words.length; i++) {
    const w = words[i];
    words[i] = w[0].toUpperCase() + w.slice(1);
  }

  return `${words[0][0]}${words[1] ? words[1][0] : ''}`;
}
